export const EXTRA_ODDS_RATE_ASSET_TYPE = '-1'
export const GAME_BANNER_TEXT_LENGTH = {
  MIN_DESC: 1,
  MAX_DESC: 20,
  MIN_MESSAGE_TITLE: 0,
  MAX_MESSAGE_TITLE: 250,
  MIN_MESSAGE_CONTENT: 0,
  MAX_MESSAGE_CONTENT: 1000,
}
export const GAME_BANNER_VALUE_RANGE = {
  MIN_ORDER: 0,
  MAX_ORDER: 20,
  MIN_BET_MONEY: 1000,
  MAX_BET_MONEY: 700000,
  MIN_REWARD_VOLUME: 1000,
  MAX_REWARD_VOLUME: 1000000,
  MIN_REWARD_COUNT: 1,
  MAX_REWARD_COUNT: 10,
  MIN_EXTRA_PAYMENT_EVENT_CONDITION: 1000,
  MAX_EXTRA_PAYMENT_EVENT_CONDITION: 10000000,
  MIN_EXTRA_PAYMENT_EVENT_REWARD_VOLUME: 1000,
  MAX_EXTRA_PAYMENT_EVENT_REWARD_VOLUME: 10000000,
}

export const GAME_MAIN_HOME_BANNER_ROLLING_RANGE = {
  MIN_ROLLING_SECOND: 1,
  MAX_ROLLING_SECOND: 10,
}

// 메타 데이터 관리 > 플레이어 리스트
export const META_PLAYER_CUSTOM_NAME_LENGTH = {
  MIN: 1,
  MAX: 50,
}
// 페이지당 개수: 화면은 OPTIONS 중 선택, 서버는 MIN~MAX 로 제한
export const META_PLAYER_LIST_ROWS_PER_PAGE = {
  MIN: 150,
  MAX: 500,
  OPTIONS: [150, 250, 500],
}

// 플레이어 마켓 제공 '토글 최종 적용' 1회 최대 변경 수
export const META_PLAYER_MARKET_ACTIVE_APPLY_MAX = 1000
// 플레이어 마켓 제공 변경 시 캐시를 다시 만드는 경기 범위: 경기 시작 시각이 현재 기준 이 일수 이전 이후인 경기 (경기 결과 표시 기간과 동일)
export const META_PLAYER_MARKET_CACHE_REBUILD_PAST_DAYS = 1

// 플레이어 리스트 검색 유형. 화면 드롭다운 순서는 META_PLAYER_SEARCH_TYPE_OPTIONS, 기본값은 CUSTOM_NAME_KO
export enum META_PLAYER_SEARCH_TYPE {
  CUSTOM_NAME_KO = 'customNameKo',
  EN = 'en',
  ID = 'id',
}
export const META_PLAYER_SEARCH_TYPE_OPTIONS = [
  { value: META_PLAYER_SEARCH_TYPE.CUSTOM_NAME_KO, text: 'CustomName.Ko' },
  { value: META_PLAYER_SEARCH_TYPE.EN, text: 'En' },
  { value: META_PLAYER_SEARCH_TYPE.ID, text: 'ID' },
]

export const USER_PICK_SEARCH_TYPE = {
  NICK: 'nick',
}

export const USER_ACTIVITY_SEARCH_TYPE = {
  // 나도 승부사
  USER_PICK: 'user_pick',
  USER_PICK_COMMENT: 'user_pick_comment',
  // 회사픽 [고정배, 프리미엄 분석가] 댓글
  COMPANY_PICK_COMMENT: 'company_pick_comment',
}

// admin 에서 재화 및 아이템 지급 시 1회 지급 최대 한도 (STD)
export const REWARD_FUND_LIMIT = 700000

// admin 에서 특정 ID로 재화 및 아이템 지급 시 1회 지급 최대 한도 (STD)
export const HIGH_REWARD_FUND_LIMIT = 10_000_000

export enum CHAT_MANAGER_CS_REPORT_TYPE {
  BALANCE_DELAY,
  BUG,
  MANUAL_QUESTION,
  BLOCK_USER_REPORT,
  ETC,
}

export enum CHAT_MANAGER_CS_ANSWER_STATE {
  UNANSWERED,
  PENDING,
  COMPLETED,
  CANCELLED,
}

export enum CHAT_MANAGER_CS_SEARCH_KEYWORD_TYPE {
  ID = 'id',
  QUESTIONER_ADMIN_NAME = 'questionerAdminName',
  REPORT_USER_NICK_NAME = 'reportUserNickName',
  QUESTION_CONTENT = 'questionContent',
}

export enum RISK_TELEGRAM_ALARM_REACT_TYPE {
  MONITORING,
  BLOCK,
  ETC,
  CARE,
}

export enum RISK_TELEGRAM_ALARM_TYPE {
  IP,
  NICK,
  PHONE,
  MESSAGE,
}

export const IP_V4_CHECK_REGEX
  = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/

export enum PAYMENT_COLLECTION_TYPE {
  PAYMENT,
  COLLECT,
  COLLECT_ALL_WITH_STD,
  COLLECT_ALL_WITHOUT_STD,
}

export enum REWARD_FUND_LOG {
  MOVE_TYPE_CONSUME = 0,
  MOVE_TYPE_CHARGE = 1,
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  SUB_TYPE_ALL = 0,
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  SUB_TYPE_JOB = 1,
  SUB_TYPE_GROUP = 2,
  SUB_TYPE_USER = 3,
  SUB_TYPE_OWNER = 4,
}

export const MONEY_ITEM = {
  CASH: { ID: 1, UNIT: 'cash', TEXT: 'S캐시' },
  MILEAGE: { ID: 2, UNIT: 'mileage', TEXT: '마일리지' },
  POINT: { ID: 3, UNIT: 'point', TEXT: '포인트' },
  G_MONEY: { ID: 4, UNIT: 'money', TEXT: 'G머니' },
  HEART: { ID: 5, UNIT: 'heart', TEXT: '하트' },
  BET_TICKET: { ID: 75, UNIT: 'ticket', TEXT: '베팅권' },
  DIA: { ID: 81, UNIT: 'dia', TEXT: '다이아' },
  DIA_CASINO: { ID: -1, UNIT: 'dia_casino', TEXT: '카지노 다이아' }, // 카지노 전용 다이아 재화.
}

export const BET_MONEY_TYPE = {
  G_MONEY: { ID: 4, KEY: 'money' },
  HEART: { ID: 5, KEY: 'heart' },
  G_TICKET: { ID: 75, KEY: 'ticket' },
  DIA: { ID: 81, KEY: 'dia' },
}

export enum GROUP_ID {
  NONE = 0,
  ODDS_GROUP = 2,
  TARGET_GROUP = 3,
}

export enum CLUB_TYPE {
  OPEN,
  SPECIFIC,
}

export const MODE = {
  PAYMENT: 'payment',
  COLLECTION: 'collection',
}

export const TYPE = {
  MONEY: 'money',
  ITEM: 'item',
  MESSAGE: 'message',
}

export const COUPON_USED_STATE = {
  NON_USED: 0,
  USED: 1,
}

export enum META_TYPE {
  MARKET = 'market',
  VARIANT = 'variant',
  MATCH_STATUS = 'match_status',
}

export enum USER_KICK_TYPE {
  USER,
  TOTAL_BETTOR
}

export enum PAYMENT_RESULT_STATE {
  SUCCESS,
  HALF_SUCCESS,
  FAIL,
  MAX_COUNT_EXCEED,
}

export const MAX_REWARD_ID_LIST = [
  'dev.lhn',
  'msd.psn',
  'ceo.hms',
]

// 1회지급한도 10,000,000 STD 지급이 가능한 어드민 목록
// 0009737: [어드민] 재화 지급_1회지급한도_STD제한_변경
// https://task.zempublic.co.kr/view.php?id=9737
export const HIGH_REWARD_ID_LIST = [
  'duddnd',
  'crm.nkm',
  'ghkdwnfl',
]

export const USER_SEARCH_TYPE_KEY = {
  ACCOUNT: 'account',
  NICK: 'nick',
  USER_NUM: 'userNum',
  EMAIL: 'email',
  PHONE: 'phone',
  RECOMMENDER: 'recommender',
  NAME: 'name',
  DUPLICATION_NICK: 'dupNick',
  DUPLICATION_ACCOUNT: 'dupAccount',
  USER_PICK_WORKER_ACCOUNT: 'userPickWorkerAccount',
  COMMENT_MANAGER_ACCOUNT: 'commentManagerAccount',
  PROMISE_ID: 'userPromiseId',
}

export const MIN_LIMIT_ODDS_MONEY = 1_000
export const MAX_LIMIT_ODDS_MONEY = 1_000_000_000

export enum ACTIVITY_SCORE_FORMAT_TYPE {
  COMMON,
  CHAT_ACQUIRED_DELAY_TIME,
  POST_LIMIT_MULTIPLE_SCORES,
}

export enum ACTIVITY_HISTORY_TYPE {
  SCORE,
  REWARD,
}

export enum MESSAGE_DIRECTION_TYPE {
  TOTAL,
  SENDER,
  RECEIVER,
}

export enum GLOBAL_EDIT_TYPE {
  ADD,
  EDIT,
  DELETE,
}

export const SPORT_FILTER_ORDER_CATEGORY = {
  MATCHUP_ETC: 'MATCHUP_ETC',
  LEAGUE: 'LEAGUE',
}

export const SPORT_FILTER_ORDER_CATEGORY_TO_FIELD = {
  MATCHUP_ETC: 'matchupFilterOrder',
  LEAGUE: 'leagueFilterOrder',
}

export enum TODAY_BEST_PICK_SCHEDULE_STATUS {
  PENDING,
  SUCCESS,
  FAILED,
}

export enum TODAY_BEST_PICK_INVALID_REASON {
  NONE,
  NOT_FOUND,
  NOT_ENABLED,
  NOT_FOUND_ACCOUNT,
  ALREADY_BEST_PICK,
  PREVIOUS_USER_PICK,
  REGARDLESS_CI,
  REGARDLESS_ACCOUNT
}

export enum RANKING_REWARD_STATUS {
  READY = 0,
  PROCESSING = 1,
  COMPLETED = 2,
  FAILED = 3,   // 1건 이상 지급 실패 시
}

export enum RANKING_REWARD_SEND_STATUS {
  COMPLETED = 0,
  ERROR = 1,
}

export enum RANKING_EVENT_HISTORY_TYPE {
  BASIC = 1,
  CONDITION = 2,
  PERIOD = 3,
  REWARD = 4,
}

export const IMAGE_UPLOAD_OPTION = {
  MAX_FILE_SIZE: 1024 * 1024 * 5,
  MAX_RESOLUTION: 2048,
}
